module.exports = __webpack_public_path__ + "img/True Yoga.898526cf.svg";